import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import LoginButton from "./LoginButton";
import { AuthContext } from "../../Auth/AuthContext";
import { useHistory, Redirect } from "react-router-dom";
const StyledLogin = styled.div`
  flex-direction: column;
  justify-content: center;
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  background-color: #21283e;
  font-family: ${(props) => props.theme.font};
  .loginCard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 35px;
    border-radius: 8px;
    background-color: #ffffff;
    margin-bottom: 20px;
  }
  h3 {
    text-align: center;
  }
  h6 {
    margin: 15px 40px 55px 40px;
    text-align: center;
  }

  h5 {
    text-align: center;
  }
  .noMatch {
    font-family: ${(props) => props.theme.font};
    margin: 25px 0;
    font-size: 20px;
    text-align: center;
  }

  .form-width {
    width: 12.6;
  }
`;

const Login = ({ login, ...props }) => {
  const { setAuthenticated, oldPath } = useContext(AuthContext);
  let history = useHistory();

  //we need to do this weird thing because logout is acting like iiffe

  const loginClick = (e) => {
    e.preventDefault();

    console.log(oldPath);
    login();
  };
  return props.authCheck ? (
    <Redirect to={{ pathname: `${oldPath}` }} />
  ) : (
    <StyledLogin>
      <div className="loginCard">
        <LoginButton onClick={loginClick} />
      </div>
    </StyledLogin>
  );
};

export default Login;
